export default __webpack_public_path__ + "static/media/MaevaAydin.7bdd81a7.webp";